<template>
  <v-card tile :elevation="0" class="crud-box list-statistics">
    <h1 class="mx-4">Manage Statistics</h1>
    <v-layout wrap class="px-4 pt-4">
      <div style="overflow: visible">
        <v-btn color="success" class="mr-2" @click="onClickNew">
          <v-icon>mdi-plus</v-icon>
          New
        </v-btn>
        <v-btn color="primary" outlined class="mr-2" @click="onClickExport">
          <v-icon>mdi-database-export</v-icon>
          Export
        </v-btn>
        <v-btn color="error" v-if="pickedItems.length > 0" class="mr-2" @click="onClickDeleteAll">
          <v-icon>mdi-delete</v-icon>
          Delete Items
        </v-btn>
      </div>
      <!---->
      <v-spacer></v-spacer>
      <v-layout wrap style="max-width: calc(100% - 250px);">
        <v-autocomplete dense outlined @keyup.enter="doSearch" class="mr-2"
                        label="Search Service" style="width: 175px"
                        :items="listServices" v-model="searchFields.service_id.value"/>
        <v-autocomplete dense outlined @keyup.enter="doSearch" class="mr-2"
                        label="Search country" style="width: 175px" item-text="name"
                        :items="listCountry" v-model="searchFields.country_id.value" item-value="id"/>
        <v-menu
          v-model="showMonthDatePicker"
          :close-on-content-click="false"
          max-width="290"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field label="Month" class="mr-2" clearable @click:clear="clearDataSearchMonth()" dense outlined readonly
                          v-on="on" v-bind="attrs" :value="searchFields.month.value"
                          @click="showMonthDatePicker = true"></v-text-field>
          </template>
          <v-date-picker
            v-model="searchFields.month.value"
            type="month"
          ></v-date-picker>
        </v-menu>
</v-layout>
      <v-btn color="primary" @click="doSearch">
        <v-icon>mdi-magnify</v-icon>
        Search
      </v-btn>
    </v-layout>

    <!--card content-->
    <v-card tile :elevation="1" :disabled="tblLoading" outlined class="block-tbl mx-4">
      <v-data-table :headers="tblHeader" :items="listItems" :server-items-length="tblPagination.total" :loading="tblLoading"
                    :footer-props="tblConfig.footerProps" @dblclick:row="onClickRow" :options.sync="tblOptions"
                    :loading-text="tblConfig.text.loading" v-model="pickedItems" :show-select="tblConfig.showSelect">
        <template v-slot:no-data>
          {{ tblConfig.text.noItem }}
        </template>

        <template v-slot:item.no="{item}">
          {{ getIndexOfItem(item) }}
        </template>
        <template v-slot:item.service_id="{item}">
          <template>
            {{ serviceGetName(item.service_id) }}
          </template>
        </template>
      <template v-slot:item.average_day="{item}">
          {{ item.average_day + item.min_day }}
      </template>
        <template v-slot:item.country_id="{item}">
          {{ item.country_id ? countryById(item.country_id).name : '' }}
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog.create" :width="800">
      <CreateItem :onCreated="onCreated" :onCancel="()=>{dialog.create=false}"></CreateItem>
    </v-dialog>
    <v-dialog v-model="dialog.detail" :width="'60%'">
      <DetailItem :selectedItem="selectedItem" :onClose="()=>{dialog.detail=false}"></DetailItem>
    </v-dialog>
    <v-dialog v-model="dialog.update" :width="800">
      <UpdateItem :onUpdated="onUpdated" :selectedItem="selectedItem" :onCancel="()=>{dialog.update=false}"></UpdateItem>
    </v-dialog>
    <v-dialog v-model="dialog.delete" :width="400">
      <DeleteItem :idsToDelete="idsToDelete" :onDeleted="onDeleted" :onCancel="()=>{dialog.delete=false}"></DeleteItem>
    </v-dialog>
    <v-dialog v-model="dialog.import" :width="400">
      <ImportItem :onImported="onImported" :onCancel="()=>{dialog.import=false}"></ImportItem>
    </v-dialog>
  </v-card>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import CreateItem from "./Create";
import DetailItem from "./Detail";
import UpdateItem from "./Update";
import DeleteItem from "./Delete";
import ImportItem from "./Import";
import indexMixin from './indexMixin';

export default {
  name: 'ManageStatistics',
  components: {CreateItem, DetailItem, UpdateItem, DeleteItem, ImportItem},
  mixins: [indexMixin],
  data() {
    return {
      searchFields: {
        service_id: {
          value: '',
          type: '=',
        },
        month: {
          value: '',
          type: 'like',
        },
        status: {
          value: '',
          type: '=',
        },
        country_id: {
          value: '226',
          type: '=',
        },
},
      searchWith: '',
      searchWithCount: '',
      tblHeader: [
        {
          text: 'No',
          value: 'no',
          sortable: false,
          groupable: false,
          width: '55px',
          align: 'start',
        },

        {
          text: 'Service',
          value: 'service_id',
        },
        {
          text: 'Month',
          value: 'month',
        },
        {
          text: 'NumberOrder',
          value: 'number_order',
        },
        {
          text: 'Vận chuyển dưới 8 ngày (%)',
          value: 'min_day',
        },
        {
          text: 'Vận chuyển 8-10 ngày (%)',
          value: 'average_day',
        },
        {
          text: 'Vận chuyển 10-12 ngày (%)',
          value: 'average_day_2',
        },
        {
          text: 'Vận chuyển trên 12 ngày (%)',
          value: 'max_day',
        },
        {
          text: 'Country',
          value: 'country_id',
        },
      ],
      showMonthDatePicker: false,
    }
  },
  computed: {
    ...mapGetters({
      items: 'statistic/all',
      tblPagination: 'statistic/pagination',
      services: 'service/all',
      countries: 'country/all',
      countryById: 'country/getById',
      serviceGetName: 'service/serviceName',
    }),
    listServices() {
      let listItems = [
        {text: 'All Service', value: ''}
      ]
      this.services.forEach(service => {
        listItems.push({
          text: service.name,
          value: service.id
        })
      });
      return listItems;
    },
    listCountry() {
      return [{id: '', name: 'None'}, ...this.countries];
    },
  },
  methods: {
    ...mapActions({
      getListItems: 'statistic/get',
      exportListItems: 'statistic/export',
    }),
    clearDataSearchMonth() {
      this.searchFields.month.value = '';
    },
  }
}
</script>
